import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box
} from '@mui/material';

const UserForm = ({ 
  open, 
  onClose, 
  formData, 
  onChange, 
  onSubmit, 
  mode = 'create',
  errors = {}
}) => {
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    onChange({
      target: {
        name,
        value: (name === 'is_admin' || name === 'show_outreach_performance') ? checked : value
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const isEditMode = mode === 'edit';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditMode ? 'Edit User' : 'Create New User'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="Username"
            name="username"
            value={formData.username || ''}
            onChange={handleChange}
            error={!!errors.username}
            helperText={errors.username}
            disabled={isEditMode}
            required={!isEditMode}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Password"
            name="password"
            type="password"
            value={formData.password || ''}
            onChange={handleChange}
            error={!!errors.password}
            helperText={isEditMode ? 'Leave blank to keep current password' : errors.password}
            required={!isEditMode}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Display Name"
            name="display_name"
            value={formData.display_name || ''}
            onChange={handleChange}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Email"
            name="email"
            type="email"
            value={formData.email || ''}
            onChange={handleChange}
          />
          
          <Box mt={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={!!formData.is_admin}
                  onChange={handleChange}
                  name="is_admin"
                  color="primary"
                />
              }
              label="Administrator Access"
            />
          </Box>
          
          <Box mt={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={!!formData.show_outreach_performance}
                  onChange={handleChange}
                  name="show_outreach_performance"
                  color="primary"
                />
              }
              label="Show Outreach Performance Section"
            />
          </Box>
          
          <FormControl fullWidth margin="normal">
            <InputLabel id="role-type-label">Role Type</InputLabel>
            <Select
              labelId="role-type-label"
              id="role_type"
              name="role_type"
              value={formData.role_type || ''}
              onChange={handleChange}
              label="Role Type"
            >
              <MenuItem value="">Regular User</MenuItem>
              <MenuItem value="Supervisor">Supervisor</MenuItem>
            </Select>
            <FormHelperText>
              Supervisors can view Research History and Outreach Statistics
            </FormHelperText>
          </FormControl>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
          >
            {isEditMode ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UserForm; 